<template>
  <div class="page-main">
    <div class="flex flex-y-center m-b-10">
      <div class="flex flex-y-center">
        <span>日期范围：</span>
        <e-date-picker type="daterange" :value.sync="filterData.create_date" />
      </div>
      <div class="flex flex-y-center m-l-10">
        <span>部门员工：</span>
        <div>
          <c-cascader-department-member
            :list.sync="filterData.department_member_list"
            :showAllLevels="false"
          />
        </div>
      </div>
      <div class="flex m-l-10">
        <el-checkbox v-model="filterData.is_gong_hai">客户公海</el-checkbox>
      </div>
      <div class="flex m-l-10">
        <el-checkbox v-model="filterData.is_xin_ke_hu">新客户</el-checkbox>
      </div>
      <div class="flex m-l-10">
        <el-checkbox v-model="filterData.cheng_jiao_status">已成交</el-checkbox>
      </div>
      <div class="flex m-l-10">
        <el-checkbox v-model="filterData.bao_jia_status">已报价</el-checkbox>
      </div>
    </div>
    <!-- 表格 -->
    <vxe-grid ref="refTable" v-bind="tableOptions" @sort-change="sortChangeEvent">
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          @change="headerFilterChange"
        />
      </template>
      <template #header_select="{ column }">
        <c-table-header
          type="select"
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :list="getLevelList(column.field)"
          :value.sync="filterData[column.field]"
        />
      </template>

      <!-- slot_default -->
      <template #default_create_date="{ row }">
        {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
      </template>
      <template #default_seq="{ $rowIndex }">
        <span :class="seqClass($rowIndex)">{{ $rowIndex + 1 }}</span>
      </template>
      <template #default_company_name="{ row, $rowIndex }">
        <el-link type="primary" @click="remarkFollowUp(row.id)">
          <span :class="seqClass($rowIndex)">{{ row.company_name }}</span>
        </el-link>
      </template>
      <template #default_saler_name="{ row, $rowIndex }">
        <span :class="seqClass($rowIndex)">{{ row.saler_name }}</span>
      </template>
      <template #default_operate="{ row }">
        <el-button type="primary" size="mini" @click="itemEdit(row.id)">编辑</el-button>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改客户 -->
    <b-popup-customer
      v-if="isShowPopupCustomer"
      :show.sync="isShowPopupCustomer"
      :id="activeId"
      @success="searchListData"
    />

    <!-- 弹窗-跟进记录 -->
    <b-popup-customer-follow-up
      v-if="isShowPopupCustomerFollowUp"
      :show.sync="isShowPopupCustomerFollowUp"
      :id="activeId"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterData: {
        create_date: [this.$util.getDate().today, this.$util.getDate().today],
        department_member_list: [],
        is_gong_hai: false,
        is_xin_ke_hu: false,
        cheng_jiao_status: false,
        bao_jia_status: false,

        saler_name: '',
        company_name: '',
        cheng_jiao_dan_shu: '',
        cheng_jiao_jin_e: '',
        cheng_jiao_li_run: '',
        cheng_jiao_li_run_lv: '',
        history_level: [],
        cheng_jiao_li_run_level: [],
        bao_jia_dan_shu: '',
        bao_jia_jin_e: '',
        bao_jia_li_run: '',
        bao_jia_li_run_lv: '',
        bao_jia_level: [],
        bao_jia_li_run_level: [],
        shang_ci_xia_dan_tian_shu: '',
        shang_ci_bao_jia_tian_shu: '',
        gen_jin_date_tian_shu: '',
        gen_jin_level: []
      },
      headerFilterUrl: '/admin/gcvip/workBench/chengjiaoSearchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',

        border: true,
        'show-footer': true,
        'max-height': this.$util.getViewHeight() - 36 - 186,
        pagerConfig: {
          ...this.$constant.page
        },
        'footer-method': this.footerMethod,
        'sort-config': {
          remote: true,
          trigger: 'default',
          orders: ['desc', 'asc'],
          defaultSort: {
            field: 'cheng_jiao_jin_e',
            order: 'desc'
          }
        },
        columns: [
          { type: 'seq', title: '排名', width: 43, slots: { default: 'default_seq' } },
          {
            title: '对象',
            children: [
              {
                field: 'saler_name',
                title: '业务员',
                width: 100,
                sortable: true,
                slots: { header: 'header_input', default: 'default_saler_name' }
              },
              {
                field: 'company_name',
                title: '客户名称',
                width: 200,
                sortable: true,
                slots: { header: 'header_input', default: 'default_company_name' }
              }
            ]
          },
          {
            title: '成交',
            children: [
              {
                field: 'cheng_jiao_dan_shu',
                title: '成交单数',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'cheng_jiao_jin_e',
                title: '金额(元)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'cheng_jiao_li_run',
                title: '利润(元)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'cheng_jiao_li_run_lv',
                title: '利润率(%)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'history_level',
                title: '金额等级',
                sortable: true,
                slots: { header: 'header_select' }
              },
              {
                field: 'cheng_jiao_li_run_level',
                title: '利润等级',
                sortable: true,
                slots: { header: 'header_select' }
              }
            ]
          },
          {
            title: '报价',
            children: [
              {
                field: 'bao_jia_dan_shu',
                title: '报价单数',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'bao_jia_jin_e',
                title: '金额(元)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'bao_jia_li_run',
                title: '利润(元)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'bao_jia_li_run_lv',
                title: '利润率(%)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'bao_jia_level',
                title: '金额等级',
                sortable: true,
                slots: { header: 'header_select' }
              },
              {
                field: 'bao_jia_li_run_level',
                title: '利润等级',
                sortable: true,
                slots: { header: 'header_select' }
              }
            ]
          },
          {
            title: '距上次',
            children: [
              {
                field: 'shang_ci_xia_dan_tian_shu',
                title: '下单(天)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'shang_ci_bao_jia_tian_shu',
                title: '报价(天)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'gen_jin_date_tian_shu',
                title: '跟进(天)',
                sortable: true,
                slots: { header: 'header_input' }
              },
              {
                field: 'gen_jin_level',
                title: '跟进等级',
                sortable: true,
                slots: { header: 'header_select' }
              }
            ]
          },
          { title: '操作', width: 60, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      sortField: 'cheng_jiao_jin_e',
      sortOrder: 'desc',
      isShowPopupCustomer: false,
      isShowPopupCustomerFollowUp: false,
      activeId: null,
      totalObj: {
        xin_zeng_ke_hu_total: '',
        cheng_jiao_jin_e_total: '',
        cheng_jiao_dan_shu_total: '',
        cheng_jiao_li_run_total: '',
        bao_jia_jin_e_total: '',
        bao_jia_dan_shu_total: '',
        bao_jia_li_run_total: ''
      }
    }
  },
  computed: {
    chengJiaoLevelList() {
      let list = this.$util.deepCopy(this.$constant.customerLevelList)
      list.forEach((item) => {
        item.val = `C${item.val}`
      })
      return list
    },
    baoJiaLevelList() {
      let list = this.$util.deepCopy(this.$constant.customerLevelList)
      list.forEach((item) => {
        item.val = `B${item.val}`
      })
      return list
    },
    genJinLevelList() {
      let list = this.$util.deepCopy(this.$constant.genJinLevelList)
      list.forEach((item) => {
        item.val = `G${item.val}`
      })
      return list
    }
  },
  watch: {
    filterData: {
      handler() {
        this.searchListData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 排名样式
    seqClass(index) {
      let result = []
      if (index < 3) result.push('f-bold')
      if (index === 0) result.push('c-st')
      if (index === 1) result.push('c-nd')
      if (index === 2) result.push('c-rd')
      return result
    },
    getLevelList(field) {
      let result = []
      if (field === 'history_level' || field === 'cheng_jiao_li_run_level') {
        result = this.chengJiaoLevelList
      }
      if (field === 'bao_jia_level' || field === 'bao_jia_li_run_level') {
        result = this.baoJiaLevelList
      }
      if (field === 'gen_jin_level') {
        result = this.genJinLevelList
      }

      return result
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true

      // 筛选参数
      let data = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        filterData: {},
        sortData: {}
      }
      Object.keys(this.filterData).forEach((key) => {
        if (key === 'department_member_list') {
          let len = this.filterData[key].length
          if (len) {
            let departmentMemberId = this.filterData[key][len - 1]
            let isBumen = typeof departmentMemberId === 'number'
            if (isBumen) {
              data.filterData.bumen_id = departmentMemberId // 部门
            } else {
              data.filterData.saler_id = Number(departmentMemberId.slice(5)) // 员工，去除'user_'
            }
          }
        } else if (key === 'cheng_jiao_status') {
          if (this.filterData[key]) data.filterData[key] = '已成交'
        } else if (key === 'bao_jia_status') {
          if (this.filterData[key]) data.filterData[key] = '已报价'
        } else {
          if (this.filterData[key]) data.filterData[key] = this.filterData[key]
        }
      })

      data.sortData[this.sortField] = this.sortOrder // 排序
      this.$api({
        method: 'post',
        url: '/admin/gcvip/workBench/chengjiao',
        data
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
            Object.keys(this.totalObj).forEach((key) => {
              this.totalObj[key] = res.data[key]
            })
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    sortChangeEvent(data) {
      this.sortField = data.field
      this.sortOrder = data.order
      this.searchListData()
    },
    // 客户编辑
    itemEdit(id) {
      this.activeId = id
      this.isShowPopupCustomer = true
    },
    // 记录-详情
    remarkFollowUp(id) {
      this.activeId = id
      this.isShowPopupCustomerFollowUp = true
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'company_name')
            return `新增客户数：${this.totalObj.xin_zeng_ke_hu_total}`
          if (column.field === 'cheng_jiao_jin_e') return this.totalObj.cheng_jiao_jin_e_total
          if (column.field === 'cheng_jiao_dan_shu') return this.totalObj.cheng_jiao_dan_shu_total
          if (column.field === 'cheng_jiao_li_run') return this.totalObj.cheng_jiao_li_run_total
          if (column.field === 'bao_jia_jin_e') return this.totalObj.bao_jia_jin_e_total
          if (column.field === 'bao_jia_dan_shu') return this.totalObj.bao_jia_dan_shu_total
          if (column.field === 'bao_jia_li_run') return this.totalObj.bao_jia_li_run_total
        })
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .c-st {
    color: #ff6400;
  }
  .c-nd {
    color: #42b983;
  }
  .c-rd {
    color: #f2be45;
  }
}
</style>
